module.exports = __webpack_public_path__ + "0aabd3bf0f99280fc18e66a11a84d386.pdf";